import { createSelector } from '@reduxjs/toolkit';
import menusSelector from './menus';

const sidebarSubmenuSelector = createSelector(menusSelector, (menus) => menus.sidebarSubmenu);

export default sidebarSubmenuSelector;
